import type { AraChunk } from './types';

export function splitIntoLines(buffer: string): { lines: string[]; rest: string } {
  const parts = buffer.split(/\r?\n/);
  const rest = parts.pop() ?? '';
  return { lines: parts, rest };
}

export function parseLine(line: string): AraChunk | null {
  const trimmed = line.trim();
  if (!trimmed) return null;
  const payload = trimmed.startsWith('data:') ? trimmed.slice(5).trim() : trimmed;
  try {
    const obj = JSON.parse(payload);
    if (obj && typeof obj === 'object' && 'type' in obj) {
      return obj as AraChunk;
    }
  } catch {
    // ignore malformed/partial lines
  }
  return null;
}


